import { render, staticRenderFns } from "./TentangKami.vue?vue&type=template&id=713dc484&scoped=true"
import script from "./TentangKami.vue?vue&type=script&lang=js"
export * from "./TentangKami.vue?vue&type=script&lang=js"
import style0 from "./TentangKami.vue?vue&type=style&index=0&id=713dc484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713dc484",
  null
  
)

export default component.exports